import { createReducer, on } from '@ngrx/store';
import { 
  WORK_DAY_FIND_SUCCESS,
  WORK_DAY_FAILED,
  WORK_DAY_UPDATE_LOADING,
 } from '../actions'
import { WorkDay } from '@core/models';

 
export interface WorkDayState {
  loading: boolean;
  workDay: WorkDay | null;
  workDayList: WorkDay[] | null;
  error: string | null;
}

const initialState: WorkDayState = {
  loading: false,
  workDay: null,
  workDayList: null,
  error: null,
}

export const workDayReducer = createReducer(
  initialState,
  on(WORK_DAY_FIND_SUCCESS, (state, { workDay }) => ({ ...state, workDay })),
  on(WORK_DAY_FAILED, (state, { error }) => ({ ...state, error })),
  on(WORK_DAY_UPDATE_LOADING, (state, { loading }) => ({ ...state, loading })),
);
